var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('client-only',[_c('AuthModal',{ref:"auth",attrs:{"login-title":"Login to add this credit to your account!","register-title":"Register to add this credit to your account!"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }